import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BlogRoutingModule } from './blog-routing.module';
import { BlogComponent } from './blog.component';

import { PoolCareInfoComponent } from './pool-care-info/pool-care-info.component';
import { FiveTipsForGettingRidOfHotTubFoamComponent } from './five-tips-for-getting-rid-of-hot-tub-foam/five-tips-for-getting-rid-of-hot-tub-foam.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { FiveSimpleStepsToProperlyMaintainYourPoolComponent } from './five-simple-steps-to-properly-maintain-your-pool/five-simple-steps-to-properly-maintain-your-pool.component';
import { SironasSimplyThreeStepWaterProgramComponent } from './sironas-simply-three-step-water-program/sironas-simply-three-step-water-program.component';
import { MyPoolHutOpeningAnnouncementComponent } from './my-pool-hut-opening-announcement/my-pool-hut-opening-announcement.component';
import { FreshwaterSaltSystemCartridgesNowAvailableComponent } from './freshwater-salt-system-cartridges-now-available/freshwater-salt-system-cartridges-now-available.component';
import { BioguardThreeStepProgramComponent } from './bioguard-three-step-program/bioguard-three-step-program.component';
import { WinterizeWithBioguardComponent } from './winterize-with-bioguard/winterize-with-bioguard.component';
import { ColdPlungeWithSironaSpaCareComponent } from './cold-plunge-with-sirona-spa-care/cold-plunge-with-sirona-spa-care.component';
import { HowToPurgeHotTubWithAhhSomeComponent } from './how-to-purge-hot-tub-with-ahh-some/how-to-purge-hot-tub-with-ahh-some.component';
import { GetYourHotTubReadyForWinterComponent } from './get-your-hot-tub-ready-for-winter/get-your-hot-tub-ready-for-winter.component';
import { HowToOpenPoolForSeasonComponent } from './how-to-open-pool-for-season/how-to-open-pool-for-season.component';
import { WhyPoolifePhospateRemoverTransformsMaintenanceComponent } from './why-poolife-phospate-remover-transforms-maintenance/why-poolife-phospate-remover-transforms-maintenance.component';

@NgModule({
    imports: [
    BlogRoutingModule,
    CommonModule,
    NgxSpinnerModule,
    BlogComponent,
    PoolCareInfoComponent,
    FiveTipsForGettingRidOfHotTubFoamComponent,
    FiveSimpleStepsToProperlyMaintainYourPoolComponent,
    SironasSimplyThreeStepWaterProgramComponent,
    MyPoolHutOpeningAnnouncementComponent,
    FreshwaterSaltSystemCartridgesNowAvailableComponent,
    BioguardThreeStepProgramComponent,
    WinterizeWithBioguardComponent,
    ColdPlungeWithSironaSpaCareComponent,
    HowToPurgeHotTubWithAhhSomeComponent,
    GetYourHotTubReadyForWinterComponent,
    HowToOpenPoolForSeasonComponent,
    WhyPoolifePhospateRemoverTransformsMaintenanceComponent
]
})
export class BlogModule { }
